import _defineProperty from "/Users/danknasty/linux/Reactive-Resume/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/Users/danknasty/linux/Reactive-Resume/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { forwardRef, useState, useRef } from 'react';
import { getDefaultZIndex, extractSystemStyles, InputWrapper, Input, Popper, Paper, Modal, CloseButton } from '@mantine/core';
import { useUuid, useFocusTrap, useClickOutside, useWindowEvent, useMergedRef } from '@mantine/hooks';
import useStyles from './DatePickerBase.styles.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

var RIGHT_SECTION_WIDTH = {
  xs: 24,
  sm: 30,
  md: 34,
  lg: 40,
  xl: 44
};
var DatePickerBase = forwardRef(function (_a, ref) {
  var _b = _a,
      classNames = _b.classNames,
      className = _b.className,
      style = _b.style,
      styles = _b.styles,
      wrapperProps = _b.wrapperProps,
      required = _b.required,
      _b$allowFreeInput = _b.allowFreeInput,
      allowFreeInput = _b$allowFreeInput === void 0 ? false : _b$allowFreeInput,
      label = _b.label,
      error = _b.error,
      id = _b.id,
      description = _b.description,
      placeholder = _b.placeholder,
      _b$shadow = _b.shadow,
      shadow = _b$shadow === void 0 ? "sm" : _b$shadow,
      _b$transition = _b.transition,
      transition = _b$transition === void 0 ? "pop-top-left" : _b$transition,
      _b$transitionDuration = _b.transitionDuration,
      transitionDuration = _b$transitionDuration === void 0 ? 200 : _b$transitionDuration,
      transitionTimingFunction = _b.transitionTimingFunction,
      _b$closeDropdownOnScr = _b.closeDropdownOnScroll,
      closeDropdownOnScroll = _b$closeDropdownOnScr === void 0 ? false : _b$closeDropdownOnScr,
      _b$size = _b.size,
      size = _b$size === void 0 ? "sm" : _b$size,
      children = _b.children,
      inputLabel = _b.inputLabel,
      _b$__staticSelector = _b.__staticSelector,
      __staticSelector = _b$__staticSelector === void 0 ? "DatePickerBase" : _b$__staticSelector,
      dropdownOpened = _b.dropdownOpened,
      setDropdownOpened = _b.setDropdownOpened,
      _b$dropdownType = _b.dropdownType,
      dropdownType = _b$dropdownType === void 0 ? "popover" : _b$dropdownType,
      _b$dropdownPosition = _b.dropdownPosition,
      dropdownPosition = _b$dropdownPosition === void 0 ? "flip" : _b$dropdownPosition,
      _b$clearable = _b.clearable,
      clearable = _b$clearable === void 0 ? true : _b$clearable,
      clearButtonLabel = _b.clearButtonLabel,
      onClear = _b.onClear,
      _b$positionDependenci = _b.positionDependencies,
      positionDependencies = _b$positionDependenci === void 0 ? [] : _b$positionDependenci,
      _b$zIndex = _b.zIndex,
      zIndex = _b$zIndex === void 0 ? getDefaultZIndex("popover") : _b$zIndex,
      _b$withinPortal = _b.withinPortal,
      withinPortal = _b$withinPortal === void 0 ? true : _b$withinPortal,
      onBlur = _b.onBlur,
      onFocus = _b.onFocus,
      onChange = _b.onChange,
      onKeyDown = _b.onKeyDown,
      _b$name = _b.name,
      name = _b$name === void 0 ? "date" : _b$name,
      sx = _b.sx,
      _b$amountOfMonths = _b.amountOfMonths,
      amountOfMonths = _b$amountOfMonths === void 0 ? 1 : _b$amountOfMonths,
      onDropdownClose = _b.onDropdownClose,
      onDropdownOpen = _b.onDropdownOpen,
      _b$clickOutsideEvents = _b.clickOutsideEvents,
      clickOutsideEvents = _b$clickOutsideEvents === void 0 ? ["mousedown", "touchstart"] : _b$clickOutsideEvents,
      modalZIndex = _b.modalZIndex,
      errorProps = _b.errorProps,
      labelProps = _b.labelProps,
      descriptionProps = _b.descriptionProps,
      _b$clearButtonTabInde = _b.clearButtonTabIndex,
      clearButtonTabIndex = _b$clearButtonTabInde === void 0 ? 0 : _b$clearButtonTabInde,
      others = __objRest(_b, ["classNames", "className", "style", "styles", "wrapperProps", "required", "allowFreeInput", "label", "error", "id", "description", "placeholder", "shadow", "transition", "transitionDuration", "transitionTimingFunction", "closeDropdownOnScroll", "size", "children", "inputLabel", "__staticSelector", "dropdownOpened", "setDropdownOpened", "dropdownType", "dropdownPosition", "clearable", "clearButtonLabel", "onClear", "positionDependencies", "zIndex", "withinPortal", "onBlur", "onFocus", "onChange", "onKeyDown", "name", "sx", "amountOfMonths", "onDropdownClose", "onDropdownOpen", "clickOutsideEvents", "modalZIndex", "errorProps", "labelProps", "descriptionProps", "clearButtonTabIndex"]);

  var _useStyles = useStyles({
    size: size,
    invalid: !!error
  }, {
    classNames: classNames,
    styles: styles,
    name: __staticSelector
  }),
      classes = _useStyles.classes,
      cx = _useStyles.cx,
      theme = _useStyles.theme;

  var _extractSystemStyles = extractSystemStyles(others),
      systemStyles = _extractSystemStyles.systemStyles,
      rest = _extractSystemStyles.rest;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      dropdownElement = _useState2[0],
      setDropdownElement = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      rootElement = _useState4[0],
      setRootElement = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      referenceElement = _useState6[0],
      setReferenceElement = _useState6[1];

  var uuid = useUuid(id);
  var focusTrapRef = useFocusTrap(!allowFreeInput && dropdownOpened);
  var inputRef = useRef();

  var closeDropdown = function closeDropdown() {
    setDropdownOpened(false);
    onDropdownClose == null ? void 0 : onDropdownClose();
  };

  var openDropdown = function openDropdown() {
    setDropdownOpened(true);
    onDropdownOpen == null ? void 0 : onDropdownOpen();
  };

  var toggleDropdown = function toggleDropdown() {
    setDropdownOpened(!dropdownOpened);
    !dropdownOpened ? onDropdownOpen == null ? void 0 : onDropdownOpen() : onDropdownClose == null ? void 0 : onDropdownClose();
  };

  var closeOnEscape = function closeOnEscape(event) {
    if (event.nativeEvent.code === "Escape") {
      closeDropdown();
      window.setTimeout(function () {
        var _a2;

        return (_a2 = inputRef.current) == null ? void 0 : _a2.focus();
      }, 0);
    }
  };

  useClickOutside(function () {
    return dropdownType === "popover" && !allowFreeInput && closeDropdown();
  }, clickOutsideEvents, [dropdownElement, rootElement]);
  useWindowEvent("scroll", function () {
    return closeDropdownOnScroll && closeDropdown();
  });
  var rightSection = clearable ? /* @__PURE__ */React.createElement(CloseButton, {
    variant: "transparent",
    "aria-label": clearButtonLabel,
    onClick: onClear,
    size: size,
    tabIndex: clearButtonTabIndex
  }) : null;

  var handleInputBlur = function handleInputBlur(event) {
    typeof onBlur === "function" && onBlur(event);

    if (allowFreeInput) {
      closeDropdown();
    }
  };

  var handleInputFocus = function handleInputFocus(event) {
    typeof onFocus === "function" && onFocus(event);

    if (allowFreeInput) {
      openDropdown();
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    typeof onKeyDown === "function" && onKeyDown(event);

    if ((event.code === "Space" || event.code === "Enter") && !allowFreeInput) {
      event.preventDefault();
      openDropdown();
    }
  };

  return /* @__PURE__ */React.createElement(InputWrapper, __spreadValues(__spreadValues({
    required: required,
    id: uuid,
    label: label,
    error: error,
    description: description,
    className: className,
    style: style,
    classNames: classNames,
    styles: styles,
    size: size,
    __staticSelector: __staticSelector,
    sx: sx,
    ref: setReferenceElement,
    errorProps: errorProps,
    descriptionProps: descriptionProps,
    labelProps: labelProps
  }, systemStyles), wrapperProps), /* @__PURE__ */React.createElement("div", {
    ref: setRootElement
  }, /* @__PURE__ */React.createElement("div", {
    className: classes.wrapper
  }, /* @__PURE__ */React.createElement(Input, __spreadValues({
    classNames: __spreadProps(__spreadValues({}, classNames), {
      input: cx(classes.input, _defineProperty({}, classes.freeInput, allowFreeInput), classNames == null ? void 0 : classNames.input)
    }),
    styles: styles,
    onClick: function onClick() {
      return !allowFreeInput ? toggleDropdown() : openDropdown();
    },
    onKeyDown: handleKeyDown,
    id: uuid,
    ref: useMergedRef(ref, inputRef),
    __staticSelector: __staticSelector,
    size: size,
    name: name,
    placeholder: placeholder,
    value: inputLabel,
    required: required,
    invalid: !!error,
    readOnly: !allowFreeInput,
    rightSection: rightSection,
    rightSectionWidth: theme.fn.size({
      size: size,
      sizes: RIGHT_SECTION_WIDTH
    }),
    onBlur: handleInputBlur,
    onFocus: handleInputFocus,
    onChange: onChange,
    autoComplete: "off"
  }, rest))), dropdownType === "popover" ? /* @__PURE__ */React.createElement(Popper, {
    referenceElement: referenceElement,
    transitionDuration: transitionDuration,
    transitionTimingFunction: transitionTimingFunction,
    forceUpdateDependencies: positionDependencies,
    transition: transition,
    mounted: dropdownOpened,
    position: dropdownPosition === "flip" ? "bottom" : dropdownPosition,
    placement: "start",
    gutter: 10,
    withinPortal: withinPortal,
    withArrow: true,
    arrowSize: 3,
    zIndex: zIndex,
    arrowClassName: classes.arrow,
    modifiers: [{
      name: "flip",
      enabled: dropdownPosition === "flip"
    }]
  }, /* @__PURE__ */React.createElement("div", {
    className: classes.dropdownWrapper,
    ref: setDropdownElement,
    "data-mantine-stop-propagation": dropdownOpened,
    onKeyDownCapture: closeOnEscape,
    "aria-hidden": allowFreeInput || void 0
  }, /* @__PURE__ */React.createElement(Paper, {
    className: classes.dropdown,
    shadow: shadow,
    ref: focusTrapRef
  }, children))) : /* @__PURE__ */React.createElement(Modal, {
    opened: dropdownOpened,
    onClose: closeDropdown,
    withCloseButton: false,
    size: amountOfMonths * 400,
    zIndex: modalZIndex
  }, children)));
});
DatePickerBase.displayName = "@mantine/dates/DatePickerBase";
export { DatePickerBase };